var _a;
import { EventsBySportIdRequest } from "sb-bff-integration";
import { ComponentType } from "../../data";
export var ComponentTypeMapper = (_a = {},
    _a[EventsBySportIdRequest.EventTypesEnum.Fixture] = function (isMiniCard) { return getFixtureType(isMiniCard); },
    _a[EventsBySportIdRequest.EventTypesEnum.Outright] = function (isMiniCard, isLive) { return getOutrightType(isLive, isMiniCard); },
    _a[EventsBySportIdRequest.EventTypesEnum.AggregateFixture] = function (isMiniCard) { return ComponentType.AggregateCard; },
    _a);
var getFixtureType = function (isMiniCard) {
    return isMiniCard
        ? ComponentType.MiniEventCard
        : ComponentType.EventCard;
};
var getOutrightType = function (eventIsLive, isMiniCard) {
    if (!eventIsLive) {
        return ComponentType.PreLiveOutright;
    }
    return isMiniCard
        ? ComponentType.MiniOutright
        : ComponentType.LiveOutright;
};
//# sourceMappingURL=ComponentTypeMapper.js.map